interface CarrierContact {
    name: string;
    id: string;
}

export interface CorrectedAPIVolumeResult {
    NSV: number;
    Corrected_Gravity: number;
}

export function getCurrentDateTimeLocal() {
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
export function convertDateTimeForm(incidentDate: Date) {
    const now = new Date(incidentDate);
    const pad = (n: number) => n.toString().padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
export function isArrayEmpty(array_1: CarrierContact|null) {
    return array_1 ? Object.keys(array_1).length : 0;
}

export function correctedAPIVolume(observedGravity: number, observeredTemperature: number, grossBarrels?: number, bsw?: number, topTemperature?: number, bottomTemperature?: number): CorrectedAPIVolumeResult {
    const density = convertGravity(observedGravity);
    var stp_density_guess = density;
    if(observeredTemperature!=60){
        if(observeredTemperature<60){
            stp_density_guess = density+10;
        }else{
            stp_density_guess = density-10;
        }
        var temporary_output = estimateAPI(density, observeredTemperature, 0);
        var count = 0;
        //Iterate using Newton-Raphson method to find the solution of the standard density that would give the observed density at the observed temperature.
        while(Math.abs(temporary_output-density) >0.001){
            const f = estimateAPI(stp_density_guess, observeredTemperature, 0) - density;
            if (Math.abs(f) < 0.001 || count > 100) {
                temporary_output = estimateAPI(stp_density_guess, observeredTemperature, 0);
                break;
            }
            // Numerical derivative
            const h = 1e-6;
            const f_prime =
            (estimateAPI(stp_density_guess + h, observeredTemperature, 0) -
                estimateAPI(stp_density_guess - h, observeredTemperature, 0)) /
            (2 * h);
            if (Math.abs(f_prime) < 1e-12) break; // avoid division by zero
            stp_density_guess = stp_density_guess - f / f_prime;
            count++;
        }
    }
    // else{
    //     //No temperature correction needed, use previously declared observed density as standard density
    // }
    if(!grossBarrels){
        grossBarrels = 0;
    }
    if(!bsw){
        bsw = 0;
    }
    if(!topTemperature || topTemperature===0){
        topTemperature = observeredTemperature;
    }
    if(!bottomTemperature || bottomTemperature===0){
        bottomTemperature = observeredTemperature;
    }
    const tank_density = estimateAPI(stp_density_guess, (topTemperature+bottomTemperature)/2, 0);
    const offloaded_oil_mass = grossBarrels * tank_density * (1-bsw/100);
    const standard_oil_volume = offloaded_oil_mass / stp_density_guess;
    const correctedGravity = convertDensity(stp_density_guess);
    return { NSV: standard_oil_volume, Corrected_Gravity: correctedGravity };
}
function estimateAPI(density:number, alt_temp:number, alt_pres:number, thermal_expansion?:number):number{
    if(!alt_pres){
        alt_pres = 0;
    }
    var alternate_temperature_IPTS68_shifted;
    var base_density_IPTS68_shifted;
    var delta_temp;
    var thermal_expansion_correction;
    var k0;
    var k1;
    var k2;
    var a;
    var b;
    var d60 = 0.01374979547;
    //console.log(density, alt_temp, alt_pres, thermal_expansion);
    if(alt_temp<-58 || alt_temp>302 || alt_pres < 0 || alt_pres >1500 || density < 610.6 || density >1163.5){
        return 0;
    }
    alternate_temperature_IPTS68_shifted = correctedTemp(alt_temp);
    
    //Assume Crude Oil Commodity Group
    k0 = 341.0957;
    k1=0;
    k2 = 0;
    a = (d60/2)*(((k0/density)+k1)*(1/density)+k2);
    b = (2*k0+k1*density)/(k0+((k1+k2*density)*density));
    base_density_IPTS68_shifted = density*(1+((Math.exp(a*(1+0.8*a))-1)/(1+a*(1+1/6*a)*b)));
    thermal_expansion_correction = ((k0/base_density_IPTS68_shifted)+k1)*(1/base_density_IPTS68_shifted)+k2;
    delta_temp = alternate_temperature_IPTS68_shifted - 60.0068749;
    var ctl;
    var fs;
    var cpl;
    ctl = Math.exp(-thermal_expansion_correction*delta_temp*(1+0.8*thermal_expansion_correction*(delta_temp+d60)));
    fs = Math.exp(-1.9947+0.00013427*alternate_temperature_IPTS68_shifted+(793920+2326.0*alternate_temperature_IPTS68_shifted)/(base_density_IPTS68_shifted*base_density_IPTS68_shifted));
    cpl = 1/(1-(Math.pow(10, -5))*fs*alt_pres);
    var cptl = ctl*cpl;
    // console.log("Thermal Expansion Correction: "+thermal_expansion_correction);
    // console.log("CTL: "+ctl);
    // console.log("CPL: "+cpl);
    // console.log("CPTL: "+cptl);
    return density*cptl;
    
}
function convertGravity(gravity:number):number{ 
    return (141.5/(gravity + 131.5)*999.016 );
}
function convertDensity(density:number):number{
    return (141.5/(density/999.016)-131.5 );
}
function correctedTemp(temperature:number):number{
    var celcius = (temperature - 32)/1.8;
    var tau = celcius/630;
    var delta = (
        -0.148759 +
            (-0.267408 +
                (1.080760+
                    (1.269056+
                        (-4.089591+
                            (-1.871251+
                                (7.438081 +
                                    -3.536296 * tau
                                )*tau
                            )*tau
                        )*tau
                    )*tau
                )*tau

            )*tau
    )*tau;
    celcius = celcius - delta;
    return (1.8*celcius + 32);
}